import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}></th>
<th parentName="tr" {...{
            "align": null
          }}></th>
<th parentName="tr" {...{
            "align": null
          }}></th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Field Name `}</strong></td>
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Details`}</strong></td>
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Example`}</strong></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger"><a parentName="td" {...{
                "href": "#competency-id"
              }}>{`Competency ID`}</a>{` - Mandatory`}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`List of unique IDs for the Competencies to be assigned to the Role, separated by a “comma”.`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`dc56c0e53854462a8cfa23e27e6c6c71 4f369b08a6724d8d8509d0931cc564a6, 6146ea960f084086ab2594508f86b012`}</td>
</tr>
</tbody>
</table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      